/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, View, type StyleProp, type ViewStyle } from 'react-native';
import { cashStyles } from './cashManagement.styles';

type Props = {
  children: React.ReactNode;
  /** Una línea de contexto — mismo patrón en todas las pestañas. */
  caption?: string;
  wrapStyle?: StyleProp<ViewStyle>;
};

/** Contenedor unificado del cuerpo de cada pestaña workspace. */
export function CashWorkspaceTabPane({ caption, children, wrapStyle }: Props) {
  return (
    <View style={[cashStyles.workspaceTabPane, wrapStyle]}>
      {caption ? <Text style={cashStyles.workspaceTabScopeCaption}>{caption}</Text> : null}
      {children}
    </View>
  );
}
